import { createUseStyles } from 'react-jss';

import { theme } from '@align-cpf/uikit-styles';

export const typographyVariantsMap = {
  body01: theme.typography.tpBody01,
  body02: theme.typography.tpBody02,
  code01: theme.typography.tpCode01,
  code02: theme.typography.tpCode02,
  label01: theme.typography.tpLabel01,
  heading01: theme.typography.tpHeading01,
  heading02: theme.typography.tpHeading02,
  heading03: theme.typography.tpHeading03,
  heading04: theme.typography.tpHeading04,
  heading05: theme.typography.tpHeading05,
  display01Light: theme.typography.tpDisplay01Light,
  display01Bold: theme.typography.tpDisplay01Bold,
  display02Light: theme.typography.tpDisplay02Light,
  display02Bold: theme.typography.tpDisplay02Bold,
  display03Light: theme.typography.tpDisplay03Light,
  display03Bold: theme.typography.tpDisplay03Bold,
  display04Light: theme.typography.tpDisplay04Light,
  display04Bold: theme.typography.tpDisplay04Bold,
} as const;

const typographyClasses = Object.keys(typographyVariantsMap).reduce(
  (acc, variant) => ({
    ...acc,
    [variant]: {
      font:
        typographyVariantsMap[variant as keyof typeof typographyVariantsMap],
    },
  }),
  {},
);

export default createUseStyles(
  {
    root: {
      '& strong, b': {
        fontWeight: 500,
      },
    },

    noWrap: {
      whiteSpace: 'nowrap',
    },

    hideOverflow: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    center: {
      textAlign: 'center',
    },
    left: {
      textAlign: 'left',
    },
    right: {
      textAlign: 'right',
    },
    ...typographyClasses,
  },

  {
    name: 'Typography',
  },
);
